import { lazy } from "react";
import { Navigate } from "react-router";
import LogoOnlyLayout from "src/layouts/LogoOnlyLayout";
import MainLayout from "../layouts/main";
import Loadable from "./Loadable";

const HomePage = Loadable(lazy(() => import("src/pages/Home")));
const About = Loadable(lazy(() => import("src/pages/About")));
const Contact = Loadable(lazy(() => import("src/pages/Contact")));
const ComingSoon = Loadable(lazy(() => import("src/pages/ComingSoon")));
const Maintenance = Loadable(lazy(() => import("src/pages/Maintenance")));
const Pricing = Loadable(lazy(() => import("src/pages/Pricing")));
const Payment = Loadable(lazy(() => import("src/pages/Payment")));
const Page500 = Loadable(lazy(() => import("src/pages/Page500")));
const NotFound = Loadable(lazy(() => import("src/pages/Page404")));

const main = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { element: <Navigate to="/auth/login" />, index: true },
      { path: "about-us", element: <About /> },
      { path: "contact-us", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "coming-soon", element: <ComingSoon /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "pricing", element: <Pricing /> },
      { path: "payment", element: <Payment /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
];

export default main;
